export default __webpack_public_path__ + "static/media/Optimize.30afdfbf.png";